import { cn } from "utils";
import { FC, useMemo } from "react";
import { LineChartSkeleton } from "../../LineChartSkeleton";
import { useHistory } from "./useHistory";
import { HistoryProps } from "./types";
import { EmptyState } from "@components/Empty";

export const History: FC<HistoryProps> = ({
  className,
  history,
  isFetching,
}) => {
  // log.debug("[History] history", history);
  const { chartRef } = useHistory({ history });
  const isEmpty = useMemo(() => {
    return !history || history.XAxis.length < 2;
  }, [history]);
  return (
    <div className={cn("w-full h-64 md:h-46.5 relative", className)}>
      <div
        className={cn("h-full h-full", { "opacity-0": isFetching || isEmpty })}
        ref={chartRef}
      />
      {isFetching && <LineChartSkeleton className="absolute inset-0" />}
      {isEmpty && !isFetching && (
        <EmptyState className="absolute inset-0" hideImage />
      )}
    </div>
  );
};
